
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

interface Options {
	name: string,
	authSEQ: string,
	birthYear: string,
	lastCode: string,
	insuredID: string,
	value: string,
}

@Component
export default class InsuredModalContent extends Vue {

	@Prop()
	insured: Options[]

	checkedList: string[] = [];

	@Inject('cacheInsuredList')
	cacheInsuredList:string[]

	created(){
		this.checkedList.push(...this.cacheInsuredList);
	}

	get indeterminateStatus(){
		return !!this.checkedList.length && this.checkedList.length < this.insured.length
	}

	get checkAllStatus(){
		return this.checkedList.length === this.insured.length;
	}

	onCheckAllChange(e) {
		this.checkedList = e.target.checked ? this.insured.map(otp => otp.value) : []
		// this.onChange(this.checkedList);
	}

	// onChange(checkedList) {
	// 	console.log('selectedList',checkedList)
	// 	this.$emit('selectedList', checkedList)
	// }

	handleBeforeSubmit(){
		this.$emit('closeModal', this.checkedList)
	}
}
